import { Button } from 'UI';
import { TestMenuButton } from 'components/TestFooter/TestFooter';
import { useAsyncAction, useNotifications } from 'hooks';
import React, { FC, useEffect, useState } from 'react';
import { actions, selectors, useAppSelector } from 'store';
import styled from 'styled-components';

type AddToFlashcardButtonProps = {
  iconMapping: Record<TestMenuButton, React.ReactNode>;
  isAddedToFlashcardInitialValue: boolean;
  questionId: string;
};

const FooterAddToFlashcardButton: FC<AddToFlashcardButtonProps> = ({
  iconMapping,
  isAddedToFlashcardInitialValue,
  questionId,
}) => {
  const [isAddedToFlashcard, setIsAddedToFlashcard] = useState(false);
  const { errorToast } = useNotifications();

  const [addQuestionToFlashcardAction, isAddLoading] = useAsyncAction(actions.flashcardsPacks.addToFlashcards);
  const [removeQuestionFromFlashcardAction, isRemoveLoading] = useAsyncAction(
    actions.flashcardsPacks.removeFromFlashcards,
  );
  const activeIndex = useAppSelector(selectors.tests.selectCurrentQuestionIndex);

  useEffect(() => {
    setIsAddedToFlashcard(isAddedToFlashcardInitialValue);
  }, [activeIndex, isAddedToFlashcardInitialValue]);

  const isLoading = isAddLoading || isRemoveLoading;

  const addQuestionToFlashcard = async () => {
    try {
      await addQuestionToFlashcardAction({ questionId });
    } catch (error) {
      errorToast('Something went wrong');
    }
  };

  const removeQuestionFromFlashcard = async () => {
    try {
      await removeQuestionFromFlashcardAction({ questionId });
    } catch (error) {
      errorToast('Something went wrong');
    }
  };

  return (
    <>
      {isAddedToFlashcard ? (
        <StyledButton
          variant="tertiary"
          size="small"
          onClick={removeQuestionFromFlashcard}
          isLoading={isLoading}
          $isAddedToFlashcard={isAddedToFlashcard}>
          {TestMenuButton.REMOVE_FLASHCARD}
        </StyledButton>
      ) : (
        <StyledButton
          iconComponent={iconMapping[TestMenuButton.ADD_FLASHCARD]}
          variant="secondary"
          size="small"
          onClick={addQuestionToFlashcard}
          isLoading={isLoading}
          $isAddedToFlashcard={isAddedToFlashcard}>
          {TestMenuButton.ADD_FLASHCARD}
        </StyledButton>
      )}
    </>
  );
};

export default FooterAddToFlashcardButton;

const StyledButton = styled(Button)<{ $isAddedToFlashcard?: boolean }>`
  white-space: nowrap;
  width: ${({ $isAddedToFlashcard }) => ($isAddedToFlashcard ? '228px' : '197px')};
`;
